module.exports = __webpack_public_path__ + "sm.758d5f5b45e8964ff5a5.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/sm.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/sm.svg
// module chunks = styles